/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* ROUTES COMPONENT
   ========================================================================== */

import AuthRoute from 'containers/auth/auth-route'
import LayoutDefault from 'containers/layouts/default'
import Loading from 'containers/loadable-fallback/loading'
import ROUTES from './constant'
import { RouteObject } from 'react-router-dom'
import loadable from '@loadable/component'
import React from 'react'
// import HomePage from 'pages/homePage'
/**
    * Lazy load page components. Fallback to <Loading /> when in loading phase
    */
const Login = loadable(async () => await import('pages/login'), {
  fallback: <Loading />
})
const Signup = loadable(async () => await import('pages/signup'), {
  fallback: <Loading />
})

const ForgotPassword = loadable(async () => await import('pages/forgotPassword'), {
  fallback: <Loading />
})

const NotFound = loadable(async () => await import('pages/not-found'), {
  fallback: <Loading />
})

const HomePage = loadable(async () => await import('pages/homePage'), {
  fallback: <Loading />
})

const Parish = loadable(async () => await import('pages/parish'), {
  fallback: <Loading />
})

const SubParish = loadable(async () => await import('pages/subParish'), {
  fallback: <Loading />
})

const Priest = loadable(async () => await import('pages/priest'), {
  fallback: <Loading />
})

const Parishioner = loadable(async () => await import('pages/parishioner'), {
  fallback: <Loading />
})

const Family = loadable(async () => await import('pages/family'), {
  fallback: <Loading />
})

/**
    * Use <AuthRoute /> to protect authenticate pages
    */

const routes: RouteObject[] = [
  {
    path: ROUTES.login,
    element: (
         <AuthRoute>
           <Login />
         </AuthRoute>
    )
  },
  {
    path: ROUTES.signup,
    element: (
         <AuthRoute>
           <Signup />
         </AuthRoute>
    )
  },
  {
    path: ROUTES.forgotpassword,
    element: (
         <AuthRoute>
           <ForgotPassword />
         </AuthRoute>
    )
  },
  {
    path: ROUTES.homePage,
    element: (
         <AuthRoute>
           <LayoutDefault />
         </AuthRoute>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: ROUTES.parish, element: <Parish /> },
      { path: ROUTES.subParish, element: <SubParish /> },
      { path: ROUTES.priest, element: <Priest /> },
      { path: ROUTES.parishioner, element: <Parishioner /> },
      { path: ROUTES.family, element: <Family /> },
      { path: ROUTES.notfound, element: <NotFound /> }
    ]
  }
]

export default routes
